import { NudgeTypes } from '../constants';
export const Definition = {
  // This is an empty div at the root of the sidebar. Avoids the
  // complicated selection of the panel which is affected by transitions
  selector: '[data-test-id="notifications-sidebar-open"]',
  getNudgeProperties: () => {
    return {
      type: NudgeTypes.SIDEBAR_NOTIFICATIONS,
      title: 'Notifications'
    };
  }
};